import { css } from "@linaria/core";
import { theme } from "@/themes/theme.ts";

export const globalBaseTheme = css`
  :global() {
    body {
      font-family: ${theme.fontPrimary};
      font-weight: 500;
      font-size: var(--14px);
      line-height: 20px;
    }
    
    h1 {
      font-size: var(--18px);
      font-weight: 700;
    }

    h2 {
      font-size: var(--17px);
      font-weight: 600;
    }
`;
